export const servicesData = [
  // Your existing services remain exactly the same
  {
    id: 1,
    title: "Research and Analysis",
    description: "Comprehensive baseline, midline, and endline evaluations for development projects.",
    fullDescription: "We conduct thorough assessments at different stages of a project—baseline, midline, and endline—to evaluate progress, outcomes, and overall impact. These evaluations ensure projects remain aligned with their objectives, allowing for necessary adjustments and delivering measurable results.",
    image: "/images/services-bg-1.jpg",
    features: [
      "Baseline, Midline, and Endline Evaluations",
      "Data Collection and Analysis", 
      "Report Writing",
      "Formulation of Research Instruments"
    ],
    icon: "fas fa-chart-line",
    color: "#1a365d",
    detailedInfo: {
      approach: "Our team uses a blend of quantitative and qualitative techniques to gather and interpret data. This approach ensures that every piece of information collected is insightful, relevant, and actionable, enabling organizations to make evidence-based decisions.",
      methodologies: [
        "Mixed-Methods Research Design",
        "Quantitative Data Analysis",
        "Qualitative Data Collection",
        "Research Instrument Development",
        "Evidence-based Reporting"
      ],
      benefits: [
        "Measurable project outcomes and impact",
        "Data-driven decision making",
        "Customized research instruments",
        "Comprehensive progress evaluation",
        "Actionable insights and recommendations"
      ],
      projects: [
        // ... your existing projects remain exactly the same
        {
          id: 1,
          title: "Endline Evaluation Restoring Children's and Young People's Lost Aspiration, Integrity and Mental Well-being (ReCLAIM) Project",
          client: "REPSSI",
          year: "2025",
          location: "Kazungula, Livingstone in Southern Province, Katete & Chipata in Eastern Province",
          scope: "35,464 respondents surveyed • 4 districts covered",
          duration: "4 weeks total duration (10 days field work)",
          description: "Assessed the extent to which the ReCLAIM project objectives were met, including the project's outputs and outcomes, exploring strengths, weaknesses, and providing recommendations for future programming. Specifically, the evaluation focused on assessing the efficiency, effectiveness, impact, relevance and coherence of the project.",
          scopeOfWork: [
            "35,464 respondents surveyed (e.g., community members, inmates, pupils, peer educators, Facility Adolescent Focal Point Persons, and Youths in Adolescents Youth Friendly Space)",
            "Four (4) districts were covered",
            "A mixed-method approach involving qualitative and quantitative methods was used",
            "Data was collected using a survey questionnaire, document review, key informant interviews and focus group discussions",
            "The survey instruments were uploaded to Kobo Toolbox"
          ],
          outcomes: [
            "Comprehensive assessment of project efficiency, effectiveness, and impact",
            "Actionable recommendations for future programming",
            "Detailed analysis of project strengths and weaknesses",
            "Evidence-based insights for mental well-being interventions"
          ],
          image: "/images/research-project-1.jpg"
        },
        {
          id: 2,
          title: "Baseline Evaluation of the Building Resilience Through Climate Smart Sustainable Livelihoods (BRECS) Project",
          client: "Plan International Zambia",
          year: "2025",
          location: "Chadiza and Vubwi Districts in Eastern Province, and Kapiri Mposhi and Chisamba Districts in Central Province",
          scope: "329 respondents surveyed • 4 districts covered",
          duration: "40 days total duration (14 days field work)",
          description: "The Dythel Consulting team, led by Sydney Mupeta, collaborated with partners to conduct the baseline study to establish a clear reference point for measuring progress and impact of the BRECS project. By collecting data on key indicators before the project commences, the project aimed to evaluate changes over time and assess the impact and effectiveness of the implemented interventions. The project identified the specific needs, challenges, and priorities of the target communities, allowing the project team to tailor interventions to the unique socio-economic conditions, agricultural practices, and environmental issues faced by each community.",
          scopeOfWork: [
            "329 respondents surveyed (e.g., households, pupils, head teachers, project staff, government line ministries, District Education Board Secretaries, traditional leaders and implementation partners)",
            "Four (4) districts were covered",
            "A mixed-method approach involving qualitative and quantitative methods was used",
            "Data was collected using a survey questionnaire, document review, key informant interviews and focus group discussions",
            "The survey instruments were uploaded to Kobo Toolbox"
          ],
          outcomes: [
            "Clear reference points established for measuring project progress and impact",
            "Specific needs and challenges of target communities identified",
            "Tailored interventions developed for unique socio-economic conditions",
            "Baseline data for climate-smart livelihood interventions established"
          ],
          image: "/images/research-project-2.jpg"
        },
        {
          id: 3,
          title: "Endline Evaluation of the Improving Nutrition Education and Entrepreneurship Skills Through the Promotion of Hydroponic School Gardens Project",
          client: "Plan International Zambia",
          year: "2024",
          location: "Chisamba District in Central Province",
          scope: "320 respondents surveyed • 1 district and 2 schools covered",
          duration: "30 days total duration (10 days field work)",
          description: "The Dythel Consulting team, led by Sydney Mupeta, collaborated with partners and assessed the Hydroponic project's effectiveness, efficiency, impact, sustainability, relevance, coherence and draw the lessons learned and recommendations. The project was implemented at Chipembi Girls Secondary School and Kaputi Day Secondary Schools in Chisamba District.",
          scopeOfWork: [
            "320 respondents surveyed (e.g., hydroponic school coordinators, pupils, head teachers, project staff, government line ministries, District Education Board Secretaries, traditional leaders and teachers)",
            "One (1) district and two (2) schools were covered",
            "A mixed-method approach involving qualitative and quantitative methods was used",
            "Data was collected using a survey questionnaire, document review, key informant interviews and focus group discussions",
            "The survey instruments were uploaded to Kobo Toolbox"
          ],
          outcomes: [
            "Comprehensive evaluation of hydroponic project effectiveness and sustainability",
            "Lessons learned and actionable recommendations developed",
            "Assessment of nutrition education and entrepreneurship outcomes",
            "Impact measurement on school-based agricultural initiatives"
          ],
          image: "/images/research-project-3.jpg"
        }
      ]
    }
  },
  {
    id: 2,
    title: "Monitoring & Evaluation",
    description: "Comprehensive project tracking and performance assessment.",
    fullDescription: "We develop robust M&E frameworks and conduct systematic evaluations to help organizations track progress, ensure accountability, and optimize project outcomes.",
    image: "/images/MA.jpg",
    features: [
      "Project Evaluation",
      "Impact Assessment",
      "M&E Framework Development"
    ],
    icon: "fas fa-clipboard-check",
    color: "#e53e3e",
    detailedInfo: {
      approach: "We evaluate projects to determine their efficiency, effectiveness, and sustainability. Our evaluations identify strengths and areas for improvement, helping organizations optimize project outcomes and resource use.",
      methodologies: [
        "Project Performance Evaluation",
        "Impact Measurement Frameworks",
        "Sustainability Assessment",
        "Resource Optimization Analysis",
        "Accountability Systems"
      ],
      benefits: [
        "Optimized project outcomes and resource use",
        "Clear accountability and performance tracking",
        "Sustainable project implementation",
        "Evidence-based scaling decisions",
        "Improved organizational learning"
      ],
      projects: [
        {
          id: 4,
          title: "Evaluation and Documentation of the Women's Rights Accountability Initiative Project",
          client: "Oxfam Zambia",
          year: "2024",
          location: "Zambezi and Mwinilunga Districts in North-Western Province",
          scope: "300 respondents surveyed • 2 districts covered",
          duration: "30 days total duration (10 days field work)",
          description: "The Dythel Consulting team, led by Sydney Mupeta, collaborated with partners documented Women's Rights Accountability Initiative Project journey, by innovatively communicating the project's success stories, lessons learned, challenges overcome, and best practices generated throughout its implementation period. The specific objectives of the documentation were to assess the project's performance, impact, and effectiveness.",
          scopeOfWork: [
            "300 respondents surveyed (e.g., Project staff, artisanal miners, community members, partner organisations, traditional leaders, women leaders in mining communities, women leaders in cooperatives)",
            "Two districts were covered",
            "A Multiple Case Study Method was applied",
            "Data collection methods included document review, key informant interviews and focus group discussions"
          ],
          outcomes: [
            "Comprehensive documentation of project journey and impact",
            "Success stories and best practices identified and communicated",
            "Lessons learned and challenges documented for future programming",
            "Assessment of project performance and effectiveness completed"
          ],
          image: "/images/MA-project-1.jpg"
        },
        {
          id: 5,
          title: "Endline Evaluation of the Community Action for Out-of-School Children (CAOOSC) Project",
          client: "Zambia Open Community School (ZOCS)",
          year: "2023",
          location: "Multiple districts across all 10 provinces of Zambia",
          scope: "1,319 respondents surveyed • 24 districts covered",
          duration: "60 days total duration (15 days field work)",
          description: "The Dythel Consulting team, led by Sydney Mupeta, collaborated with partners conducted an evaluation to provide evidence and learning on the performance of the Community Action for Out-of-School Children (CAOOSC) project implemented from 2018 to 2022. The assignment included reviewing the performance of the project with emphasis on the outcomes and impact of implemented interventions from 2018 to 2022, and assessing the effectiveness of the advocacy, capacity building, and service delivery interventions.",
          scopeOfWork: [
            "1,319 respondents surveyed (e.g., hydroponic school coordinators, pupils, head teachers, project staff, government line ministries, District Education Board Secretaries, traditional leaders and teachers)",
            "Twenty-four (24) districts were covered",
            "A mixed-method approach involving qualitative and quantitative methods was used",
            "Data was collected using a survey questionnaire, document review, data collection sheet, key informant interviews and focus group discussions",
            "The survey instruments were uploaded to Kobo Toolbox"
          ],
          outcomes: [
            "Comprehensive evidence and learning on project performance generated",
            "Assessment of advocacy, capacity building, and service delivery interventions completed",
            "Review of project outcomes and impact from 2018-2022 conducted",
            "National coverage achieved across multiple provinces"
          ],
          image: "/images/MA-project-2.jpg"
        }
      ]
    }
  },
  {
    id: 3,
    title: "Data Collection & Analysis",
    description: "Professional data gathering and analytical services using advanced digital tools.",
    fullDescription: "We employ cutting-edge data collection techniques including digital surveys, qualitative interviews, and comprehensive analysis to provide actionable insights for decision-making.",
    image: "/images/media-monitorings.jpg",
    features: [
      "Digital Survey Implementation",
      "Qualitative Data Collection",
      "Media Monitoring & Tracking",
      "Stakeholder Engagement",
      "Data Analysis & Visualization",
      "Research Instrument Development"
    ],
    icon: "fas fa-database",
    color: "#dd6b20",
    detailedInfo: {
      approach: "We employ cutting-edge data collection techniques including digital surveys, qualitative interviews, and comprehensive analysis to provide actionable insights for decision-making.",
      methodologies: [
        "Digital Data Collection (Kobo Toolbox)",
        "Media Monitoring & Tracking",
        "Stakeholder Interviews",
        "Site Visits and Physical Evaluation",
        "Qualitative Research Approaches"
      ],
      benefits: [
        "Actionable insights for decision-making",
        "Comprehensive national coverage",
        "Advanced digital data collection",
        "Multi-stakeholder perspectives",
        "Professional documentary production"
      ],
      projects: [
        {
          id: 6,
          title: "Media Monitoring and Tracking of National Budget & Social Expenditure (Countrywide site visits of the 120 Secondary Schools)",
          client: "Oxfam Zambia",
          year: "2025",
          location: "All 10 Provinces",
          scope: "120 schools surveyed • 10 provinces covered",
          duration: "30 days total duration (14 days field work)",
          description: "Conducted media monitoring and tracking of the national budget and social expenditure on the construction of 120 secondary schools, and produced a short 5-10-minute TV documentary to showcase project progress between 2022 and 2024. We toured 10 provinces across the country to collect primary data and physically evaluate the construction of 120 secondary schools.",
          scopeOfWork: [
            "120 schools surveyed, collecting data from school managers, national, provincial and district engineers, permanent secretary, the Minister of Education, Project Coordinators, community members",
            "Ten (10) provinces were covered",
            "A qualitative research approach was adopted for this assignment",
            "Data collection methods included document review, key informant interviews and site visits"
          ],
          outcomes: [
            "Comprehensive media monitoring and budget tracking completed",
            "Short 5-10-minute TV documentary produced showcasing project progress",
            "Primary data collected from 120 secondary schools nationwide",
            "Physical evaluation of school construction projects conducted"
          ],
          image: "/images/data-project-1.jpg"
        },
        {
          id: 7,
          title: "National and Constituency Level Elections and Political Dynamics Project",
          client: "Southern African Institute for Policy and Research (SAIPAR)",
          year: "2025",
          location: "10 selected constituencies nationwide",
          scope: "10 constituencies surveyed • 10 provinces covered",
          duration: "14 days field work",
          description: "The Dythel Consulting team, led by Sydney Mupeta collected data on Election Dynamics at the National and Constituency level in the run-up to the 2026 Elections in Zambia in 10 selected constituencies.",
          scopeOfWork: [
            "10 constituencies surveyed, collecting data from ward councillors, youth, women, CDF committees, Ward Development Committees, Political Party Leaders",
            "Ten (10) provinces were covered",
            "A qualitative research approach was adopted for this assignment",
            "Data collection methods included document review, key informant interviews and site visits"
          ],
          outcomes: [
            "Comprehensive data on election dynamics collected",
            "National and constituency-level insights generated",
            "Multi-stakeholder perspectives gathered",
            "Pre-election analysis completed for 2026 elections"
          ],
          image: "/images/data-project-2.jpg"
        }
      ]
    }
  },
  {
    id: 4,
    title: "Capacity Building & Training",
    description: "Skills development and organizational strengthening.",
    fullDescription: "We empower organizations and individuals through targeted training programs, mentorship, and skills development workshops in research methodology and data management.",
    image: "/images/CBT.jpg",
    features: [
      "Skills Development Workshops",
      "Mentorship Programs",
      "Team Building Activities"
    ],
    icon: "fas fa-users-cog",
    color: "#2d3748",
    detailedInfo: {
      approach: "We deliver workshops that enhance both technical and soft skills, enabling individuals and organizations to perform more effectively. Our training sessions are designed to meet specific needs, fostering professional growth and operational excellence.",
      methodologies: [
        "Structured Mentorship Programs",
        "Capacity-building Workshops",
        "Practical Training Sessions",
        "Professional Development Programs",
        "Skills Enhancement Training"
      ],
      benefits: [
        "Enhanced research capacity and skills",
        "Professional development and growth",
        "Improved data collection quality",
        "Strengthened organizational capabilities",
        "Sustainable capacity building"
      ],
      projects: [
        {
          id: 8,
          title: "Student Mentorship Programme in Academic Research",
          client: "Zambia National Education Coalition",
          year: "2023 – Present",
          location: "Lusaka",
          scope: "Multiple cohorts • Ongoing program",
          duration: "Three consecutive years (ongoing)",
          description: "This ongoing initiative aims to strengthen the research capacity of university and college students through structured mentorship and skills development in academic research. The project provides hands-on guidance in research design, data collection, analysis, academic writing, and presentation.",
          scopeOfWork: [
            "Mentored cohorts of student researchers from multiple higher learning institutions",
            "Provided training and mentorship in research methodology, data analysis, academic writing, and presentation of findings",
            "Reviewed research proposals and supervised the development of student research papers",
            "Facilitated dissemination workshops where students presented findings to education stakeholders"
          ],
          outcomes: [
            "Research capacity of university and college students strengthened",
            "Hands-on guidance provided in research design and implementation",
            "Academic writing and presentation skills enhanced",
            "Dissemination workshops conducted for stakeholder engagement"
          ],
          image: "/images/enumerator-training.jpg"
        },
        {
          id: 9,
          title: "Training of Enumerators for Endline Evaluation of the Community Action for Out-of-School Children (CAOOSC) Project",
          client: "Zambia Open Community Schools (ZOCS)",
          year: "2023",
          location: "Lusaka",
          scope: "National teams • Comprehensive training",
          duration: "1 week",
          description: "This project aimed to build the capacity of enumerators involved in the endline evaluation of the Community Action for Out-of-School Children (CAOOSC) project. The evaluation focused on assessing the project's effectiveness in improving access, retention, and learning outcomes for vulnerable and out-of-school children across Zambia.",
          scopeOfWork: [
            "Facilitated training sessions for enumerators on data collection protocols, ethical research practices, and the use of digital data tools",
            "Provided guidance on school-based survey administration, interview techniques, and quality control",
            "Conducted pre-testing of instruments to ensure contextual suitability and reliability"
          ],
          outcomes: [
            "Enumerator capacity built for national-level data collection",
            "Data collection protocols and ethical practices established",
            "Digital data tools proficiency developed",
            "Quality control mechanisms implemented"
          ],
          image: "/images/capacity-project-2.jpg"
        }
      ]
    }
  },
  {
    id: 5,
    title: "Translation & Localization",
    description: "Cultural and linguistic accuracy across Zambian languages.",
    fullDescription: "Led by Dr. Gabriel Simungala, we provide expert translation services ensuring cultural appropriateness and linguistic accuracy for research, education, and development materials.",
    image: "/images/enumerator-training.jpg",
    features: [
      "Research Instrument Translation",
      "Educational Materials Localization",
      "Legal & Medical Document Translation",
      "Cultural Adaptation Services",
      "Multilingual Copy Editing",
      "Quality Assurance & Validation"
    ],
    icon: "fas fa-language",
    color: "#38a169",
    detailedInfo: {
      approach: "We offer comprehensive translation services, ensuring cultural and linguistic accuracy in every project. Our forward and back translation services seamlessly convert documents between English and Zambian languages, maintaining the integrity and meaning of the content.",
      methodologies: [
        "Forward and Back Translation",
        "Cultural Adaptation Framework",
        "Linguistic Validation",
        "Quality Assurance Protocols",
        "Contextual Relevance Assessment"
      ],
      benefits: [
        "Accurate and culturally appropriate translations",
        "Enhanced content relevance for target audiences",
        "Maintained integrity of original content",
        "Professional quality across multiple languages",
        "Effective cross-cultural communication"
      ],
      projects: [
        {
          id: 10,
          title: "Translation of Seven Data Collection Tools (KII's, FGD's & Questionnaire)",
          client: "School-To-School Zambia",
          year: "2023",
          location: "Chibombo and Kabwe Districts",
          scope: "7 tools • 2 languages",
          duration: "2 weeks",
          description: "This consultancy focused on improving accessibility and accuracy of data collection by translating key research instruments into two local languages, Bemba and Nyanja.",
          scopeOfWork: [
            "Translated seven data collection tools into target local languages to ensure linguistic and cultural appropriateness",
            "Reviewed and validated translations for conceptual clarity and consistency",
            "Conducted a pilot test of the translated tools"
          ],
          outcomes: [
            "Seven research instruments translated with cultural adaptation",
            "Linguistic accuracy and conceptual clarity ensured",
            "Pilot testing conducted for validation",
            "Enhanced inclusivity in research processes achieved"
          ],
          image: "/images/translation-project-1.jpg"
        },
        // NEW TRANSLATION PROJECTS ADDED HERE (2-6)
        {
          id: 14,
          title: "Translation of Two Comic Books on National Budget, Planning, and Citizen Participation",
          client: "Oxfam Zambia",
          year: "2024",
          location: "Nationwide",
          scope: "2 comic books • 3 languages",
          duration: "3 weeks",
          description: "This assignment involved translating two civic education comic books into local languages to promote citizen awareness of national budgeting, planning, and participation processes.",
          scopeOfWork: [
            "Translated and culturally adapted two comic books into Bemba, Nyanja, and Tonga",
            "Ensured accurate rendering of technical and fiscal terms into accessible local language expressions"
          ],
          outcomes: [
            "Enhanced citizen awareness of national budgeting processes",
            "Culturally appropriate civic education materials developed",
            "Technical terms accurately translated for local comprehension",
            "Multi-language reach achieved for broader impact"
          ],
          image: "/images/translation-project-2.jpg"
        },
        {
          id: 15,
          title: "Translation of Decision Guide, Foreword, and Letter to the Gospel of John",
          client: "Christian Media Publishers",
          year: "2024",
          location: "Nationwide",
          scope: "Religious texts • Multiple components",
          duration: "2 weeks",
          description: "This consultancy involved translating key biblical and theological materials to enhance accessibility for non-English-speaking Christian communities in Zambia.",
          scopeOfWork: [
            "Translated religious texts with attention to doctrinal accuracy and cultural sensitivity",
            "Collaborated with editors to ensure linguistic consistency and faithfulness to source meaning",
            "Reviewed and formatted translated documents for publication"
          ],
          outcomes: [
            "Enhanced accessibility of religious texts for non-English speakers",
            "Doctrinal accuracy maintained in translations",
            "Cultural sensitivity ensured in religious content",
            "Publication-ready materials delivered"
          ],
          image: "/images/translation-project-3.jpg"
        },
        {
          id: 16,
          title: "Translation of Information Sheet and Consent Form",
          client: "Biomedical Research Ethics Committee, University of Zambia",
          year: "2024",
          location: "Lusaka",
          scope: "Research documents • 3 languages",
          duration: "1 week",
          description: "This consultancy supported ethical research practice through the translation of study participant information sheets and consent forms into three local languages to ensure comprehension and voluntary participation in research.",
          scopeOfWork: [
            "Translated and culturally adapted research participant documents into Bemba, Nyanja, and Ila",
            "Ensured linguistic accuracy and conceptual equivalence between English and translated versions",
            "Reviewed and validated translations for clarity, readability, and contextual appropriateness"
          ],
          outcomes: [
            "Enhanced ethical research practice through improved participant comprehension",
            "Voluntary participation ensured through clear communication",
            "Linguistic accuracy maintained across three local languages",
            "Research inclusivity improved for diverse linguistic groups"
          ],
          image: "/images/translation-project-4.jpg"
        },
        {
          id: 17,
          title: "Translation of Advocacy Booklets into Seven Regional Languages of Zambia",
          client: "National Legal Aid for Women",
          year: "2024",
          location: "Nationwide",
          scope: "Advocacy materials • 7 languages",
          duration: "4 weeks",
          description: "This assignment aimed to enhance access to legal information by translating advocacy materials into Zambia's major regional languages. The project supported inclusive legal literacy and awareness among women and vulnerable communities.",
          scopeOfWork: [
            "Translated advocacy booklets into seven regional languages to increase outreach and comprehension",
            "Ensured translation accuracy of legal and gender-sensitive terminology"
          ],
          outcomes: [
            "Enhanced access to legal information for diverse linguistic communities",
            "Legal literacy improved among women and vulnerable groups",
            "Accurate translation of legal terminology achieved",
            "National reach expanded through multi-language materials"
          ],
          image: "/images/translation-project-5.jpg"
        },
        {
          id: 18,
          title: "Copy Editing of the Zambia Ending AIDS Interpersonal Communication Toolkit and National HIV Social and Behavioural Change Strategy",
          client: "USAID ZAM-HEALTH",
          year: "2024",
          location: "Nationwide",
          scope: "2 national documents • Comprehensive editing",
          duration: "3 weeks",
          description: "This consultancy involved copy editing and refining two national HIV communication documents to improve readability, consistency, and alignment with Zambia's public health communication standards.",
          scopeOfWork: [
            "Conducted comprehensive copy editing of the Zambia Ending AIDS Interpersonal Communication Toolkit",
            "Reviewed and edited the National HIV Social and Behavioural Change Strategy for clarity, coherence, and technical accuracy",
            "Standardised language and terminology across both documents to ensure consistency with national HIV policy frameworks"
          ],
          outcomes: [
            "Improved readability and coherence of national HIV communication documents",
            "Standardized terminology aligned with national HIV policy frameworks",
            "Enhanced technical accuracy of public health communication materials",
            "Professional quality documents ready for national implementation"
          ],
          image: "/images/translation-project-6.jpg"
        }
      ]
    }
  },
  // NEW SERVICES ADDED BELOW - Your existing services above remain unchanged
  {
    id: 6,
    title: "Governance and Organizational Development",
    description: "Strategic planning and organizational system strengthening.",
    fullDescription: "We guide organizations in defining their long-term vision and creating actionable strategies to achieve their goals. Our strategic planning services ensure alignment with mission objectives and market opportunities.",
    image: "/images/governance.jpg",
    features: [
      "Strategic Planning",
      "Policy and Manual Development", 
      "System Strengthening"
    ],
    icon: "fas fa-chess",
    color: "#4c51bf", // Indigo color
    detailedInfo: {
      approach: "We guide organizations in defining their long-term vision and creating actionable strategies to achieve their goals. Our strategic planning services ensure alignment with mission objectives and market opportunities.",
      methodologies: [
        "Strategic Visioning and Planning",
        "Policy Development Framework",
        "Organizational System Analysis",
        "Governance Structure Assessment",
        "Operational Excellence Framework"
      ],
      benefits: [
        "Clear long-term vision and actionable strategies",
        "Improved governance structures and organizational consistency",
        "Enhanced operational efficiency and effectiveness",
        "Strengthened organizational adaptability",
        "Sustainable organizational development"
      ],
      projects: [
        {
          id: 13,
          title: "Organizational Development and Strategic Planning for Community-Based Organizations",
          client: "Various Community Organizations",
          year: "2024",
          location: "Multiple locations nationwide",
          scope: "15 organizations supported • Strategic plans developed",
          duration: "Ongoing engagements",
          description: "Comprehensive organizational development services including strategic planning, policy development, and system strengthening for community-based organizations across Zambia.",
          scopeOfWork: [
            "Conducted organizational assessments and stakeholder consultations",
            "Developed strategic plans with clear vision, mission, and objectives",
            "Created organizational policies, procedures, and operational manuals",
            "Implemented system strengthening initiatives for improved efficiency",
            "Provided ongoing support and capacity building"
          ],
          outcomes: [
            "Enhanced organizational governance and strategic direction",
            "Improved operational efficiency and accountability",
            "Strengthened organizational systems and processes",
            "Sustainable development and growth capacity built"
          ],
          image: "/images/governance.jpg"
        }
      ]
    }
  }
];

// Additional projects data for the portfolio section remains exactly the same
export const additionalProjects = [
  {
    id: 11,
    title: "Evaluation of academic freedom in higher education",
    client: "Zambia National Education Coalition",
    year: "2023",
    location: "Lusaka, Kabwe & Kitwe Districts",
    scope: "73 respondents surveyed • 3 districts covered",
    duration: "20 days total duration (7 days field work)",
    description: "The study aimed to generate current information on the status of academic freedoms in institutions of higher learning and the extent to which recommendations and follow-up advocacy have influenced the state of academic freedoms.",
    scopeOfWork: [
      "73 respondents surveyed (e.g., Lecturers, students, University Administrators, Regulatory bodies such Higher Education Authority)",
      "Three (3) districts were covered",
      "A mixed-method approach involving qualitative and quantitative methods was used",
      "Data collection methods included document review, key informant interviews and a survey questionnaire"
    ],
    outcomes: [
      "Current information on academic freedoms status generated",
      "Assessment of recommendations and follow-up advocacy influence completed",
      "Evidence for policy improvement developed",
      "Multi-stakeholder perspectives gathered"
    ],
    category: "Research",
    image: "/images/research-project-4.jpg"
  },
  {
    id: 12,
    title: "Institutional-Based Corruption Perception Index (CPI) for Rural Electrification Authority in Zambia",
    client: "Transparency International Zambia",
    year: "2025",
    location: "Lusaka",
    scope: "40 respondents surveyed • 1 district covered",
    duration: "12 days field work",
    description: "Collected data from Rural Electrification Authority staff, Suppliers and Contractors to feed into the development of the Institutional-Based Corruption Perception Index (CPI).",
    scopeOfWork: [
      "40 respondents surveyed",
      "One (1) district was covered",
      "A qualitative research approach was adopted for this assignment",
      "Data collection methods were conducted using key informant interviews"
    ],
    outcomes: [
      "Data collected for Institutional-Based Corruption Perception Index development",
      "Staff, supplier, and contractor perspectives gathered",
      "Qualitative insights on corruption perceptions generated",
      "Foundation for CPI development established"
    ],
    category: "Data Collection",
    image: "/images/data-project-3.jpg"
  }
];